// ABOUTME: Generates personalization labels from user profile data
// ABOUTME: Used to surface onboarding choices in suggestion and recommendation UI

import type { ColorProfile, OnboardingState } from '@/lib/store/gameStore'

export function getPersonalizationLabel(
  colorProfile: ColorProfile,
  onboarding: OnboardingState
): string | null {
  const parts: string[] = []

  if (colorProfile.season) {
    const season = colorProfile.season.charAt(0).toUpperCase() + colorProfile.season.slice(1)
    parts.push(`${season} palette`)
  }

  if (onboarding.bodyType) {
    parts.push(`${onboarding.bodyType} build`)
  }

  if (parts.length === 0) return null

  return `Based on your ${parts.join(' & ')}`
}
